<div class="images_container">
  <mat-card
    class="image_thumb"
    (click)="selectImage(img)"
    (keyup.enter)="selectImage(img)"
    [tabindex]="i"
    [ngClass]="{ selected: img.id === selectedId }"
    *ngFor="let img of imageList; let i = index"
  >
    <mat-card-content
      ><img
        class="slide-thumb"
        src="{{ img.thumb_src }}"
        alt="{{ img.friendly_name }}"
    /></mat-card-content>
  </mat-card>
  <div class="no-image-advise" *ngIf="imageList?.length === 0">
    {{ labels.NOIMAGE }}
  </div>
  <span class="paginator-container" *ngIf="pageSize < count">
    <mat-paginator
      #paginator
      class="mosaic-paginator"
      (page)="handlePageEvent($event)"
      [length]="count"
      [pageSize]="pageSize"
      [showFirstLastButtons]="showFirstLastButtons"
      [pageSizeOptions]="[]"
      [hidePageSize]="hidePageSize"
      [pageIndex]="pageIndex"
      aria-label="labels.PAGINATOR"
    >
    </mat-paginator>
  </span>
</div>
